var React = require('react');

function XButton (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17 1L1 17","stroke":"#7F869E","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M1 1L17 17","stroke":"#7F869E","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

XButton.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = XButton;

XButton.default = XButton;
